import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-2 mb-4" }
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = { class: "hover-underline" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: _ctx.to,
      class: "no-underline hide-in-print"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _cache[0] || (_cache[0] = _createElementVNode("span", {
            class: "icon icon-navigation_pfeil_links mr-1",
            "aria-hidden": "true"
          }, null, -1)),
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t(_ctx.i18nMessage)), 1)
        ])
      ]),
      _: 1
    }, 8, ["to"])
  ]))
}